<template>
    <div class="splash">
        <a href='http://om.nl'><img class='omlogo' src="../assets/img-intro-om-logo.png"></a>
        <div class="subtitle"> presenteert </div>
        <div class='link-image-container'>
            <div class='link-image'>
                <img class='sound-warning' src="../assets/sound.png">
                <img class='MZBlock' src="../assets/img-intro-moordzaak-block.png">
                <div class='link'>
                    <span @click="start" @touchend="start">
                        <img class="circle" src="../assets/img-intro-play-circle.png">
                        <img class='arrow' src="../assets/img-intro-play-triangle.png">
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import './Splash.scss'
    import '../data/customEases.js'

    export default {
        name: 'Splash',
        methods: {
            start () {
                // this.$router.push('/intro')
            }
        },
        mounted () {

            if (this.$mobile) {
                TweenLite.set(".link-image", {opacity:0, scale:1, rotation:1, force3D: true});
                TweenLite.to(".link-image", 0.4, {opacity:1, scale:0.5, rotation:-1, force3D: true, delay:1, ease: Back.easeOut.config(1.7)});
            } else {
                TweenLite.set(".link-image", {opacity:0, scale:1.5, rotation:1, force3D: true});
                TweenLite.to(".link-image", 0.4, {opacity:1, scale:1, rotation:-1, force3D: true, delay:1, ease: Back.easeOut.config(1.7)});
            }

            TweenLite.to (".circle", 0.4, {scale:1.05, delay:2, force3D: true, ease: "blink" })

            $( ".link" ).hover(
              function() {
                TweenLite.to (".circle", 0.1, {scale:1.05})
                TweenLite.to (".arrow", 0.3, {x:30, opacity:0, ease: Power1.easeOut})
                TweenLite.set (".arrow", {x:-50, opacity:0, delay:0.3})
                TweenLite.to (".arrow", 0.3, {x:"-30%", opacity:1, delay:0.3, ease: Power1.easeOut})
              }, function() {
                TweenLite.to (".circle", 0.1, {scale:1})
              }
            );
        }
    }
</script>

<style>
    .sound-warning {
        position: absolute;
        right: -40%;
        bottom: 7%;
    }
</style>




// WEBPACK FOOTER //
// Splash.vue?2c6a5814